import { render, staticRenderFns } from "./AcoesTratativasComponent.vue?vue&type=template&id=49788e00&scoped=true"
import script from "./AcoesTratativasComponent.vue?vue&type=script&lang=js"
export * from "./AcoesTratativasComponent.vue?vue&type=script&lang=js"
import style0 from "./AcoesTratativasComponent.vue?vue&type=style&index=0&id=49788e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49788e00",
  null
  
)

export default component.exports